import React from 'react';
import * as PropTypes from 'prop-types';

import { Wrapper } from './elements';

function Wra6A(props) {
  return (
    <Wrapper
      className={props.className}
      onClick={props.onClick}
      style={props.style}
      id={props.id}
    >
      {props.children}
    </Wrapper>
  );
}

Wra6A.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
  id: PropTypes.string,
};

export default Wra6A;
